import type MapProperty from '../private/IMapProperty';

/**
 * @description array of each field & how to convert between external(api) & internal representations
 */
const MAPPINGS: MapProperty[] = [
    {
        localName: 'id',

        defaultValue: 0,
    },
    {
        localName: 'name',

        defaultValue: '',
    },
    {
        localName: 'fontColor',

        defaultValue: '',
    },
    {
        localName: 'fontSize',

        defaultValue: 0,
    },
    {
        localName: 'fontName',

        defaultValue: '',
    },
    {
        localName: 'backgroundColor',

        defaultValue: '',
    },
    {
        localName: 'foregroundColor',

        defaultValue: '',
    },
    {
        localName: 'description',

        defaultValue: '',
    },
    {
        localName: 'siteId',

        defaultValue: 0,
    },
    {
        localName: 'tourTypeId',

        defaultValue: 0,
    },
    {
        localName: 'tourSubTypeId',

        defaultValue: 0,
    },
    {
        localName: 'styleId',

        defaultValue: 0,
    },
    {
        localName: 'tourStatusId',

        defaultValue: 0,
    },
    {
        localName: 'stage1',

        defaultValue: false,
    },
    {
        localName: 'stage2',

        defaultValue: false,
    },
    {
        localName: 'stage3',

        defaultValue: false,
    },
    {
        localName: 'stage4',

        defaultValue: false,
    },
    {
        localName: 'createdById',

        defaultValue: 0,
    },
    {
        localName: 'modifiedById',

        defaultValue: 0,
    },
    {
        localName: 'version',

        defaultValue: 0,
    },
    {
        localName: 'minorVersion',

        defaultValue: 0,
    },
    {
        localName: 'publishedVersion',

        defaultValue: 0,
    },
    {
        localName: 'testVersion',

        defaultValue: 0,
    },
    {
        localName: 'internalName',

        defaultValue: '',
        optional: true,
    },
    {
        localName: 'grayOutContentOnPlayback',

        defaultValue: false,
        optional: true,
    },
    {
        localName: 'qrCode',

        defaultValue: '',
        optional: true,
    },
    {
        localName: 'visibilityScheduleShow',

        defaultValue: '',
        optional: true,
    },
    {
        localName: 'visibilityScheduleHide',

        defaultValue: '',
        optional: true,
    },
    {
        localName: 'siteObjectPlayOnLaunchId',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'showFloorplanOnMenuOnly',

        defaultValue: false,
        optional: true,
    },
    {
        localName: 'hideOnTourSelect',

        defaultValue: false,
        optional: true,
    },
    {
        localName: 'backButtonStyleId',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'hideKeypadNumber',

        defaultValue: false,
        optional: true,
    },
    {
        localName: 'screenOrientations',

        defaultValue: 0,
        optional: true,
    },
];

export default MAPPINGS;
